module.exports = __webpack_public_path__ + "card2.jpg?2d9a4b1ccba8ea427f4f9b4c1584e3ac";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/card2.jpg
// module id = 125
// module chunks = 0